import script from "./AppHrefLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHrefLink.vue?vue&type=script&setup=true&lang=js"

import "./AppHrefLink.vue?vue&type=style&index=0&id=63e3d7d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e3d7d3"]])

export default __exports__